<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
				headDatas: getdata().headDatas
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: [],
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			tableDatas: {
				type: Array,
				default: [],
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
			this.$nextTick(()=>{
			})
		},
		methods: {
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			spanmethods({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 3
						}
					} else if (rowIndex === 14) {
						return {
							rowspan: 1,
							colspan: 3
						};
					} else if (rowIndex === 26) {
						return {
							rowspan: 1,
							colspan: 3
						}
					} else {
						return {
							rowspan: 1,
							colspan: 1
						}
					}
				} else if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 14) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 26) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
			
					}
				} else if(columnIndex === 2) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 14) {
						return {
							rowspan: 0,
							colspan: 0
						}
					} else if (rowIndex === 26) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						}
			
					}
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 1,
							colspan: 3
						};
					} else if (rowIndex === 13) {
						return {
							rowspan: 1,
							colspan: 3
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 13) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} else if (columnIndex === 2) {
					if (rowIndex === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else if (rowIndex === 13) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {
						return {
							rowspan: 1,
							colspan: 1
						};
					}
				} 
			},
		},
		
	}
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
